<template>
  <div class="h-screen overflow-hidden flex flex-col bg-white border-solid border-l border-0 border-gray-border">
    <div class="border-solid border-b border-0 border-gray-border px-8 pb-8">
      <div class="mt-8 inline-block pr-12 w-full relative">
        <h3 class="font-semibold truncate">
          <span class="cursor-pointer text-gray-dark hover:text-primary-focus hover:underline"
                @click="$emit('display-bot-summary')"
          >{{ groupBotName }}</span>
          <span class="text-gray ml-1">/</span>
          <span class="text-black ml-1">{{ marketName }}</span>
        </h3>
        <side-list-menu v-if="menuItems.length"
                        :items="menuItems"
                        class="absolute top-0 right-0 -mt-1"
                        @delete="$emit('request-delete-market', bot)"
        />
      </div>
    </div>

    <div class="mt-8 px-8 flex flex-col gap-6 text-gray-dark">
      <div>
        <label class="font-bold">Market Type</label>
        <div class="mt-1 flex items-center gap-2">
          <span>{{ bot.is_primary_variant ? 'Primary' : 'Secondary' }}</span>
          <vs-icon icon="storefront"/>
        </div>
      </div>
      <div>
        <label class="font-bold">Language</label>
        <div class="mt-1 flex items-center gap-2">
          <span>{{ marketLanguage }}</span>
          <vs-icon icon="language"/>
        </div>
      </div>

      <div>
        <label class="font-bold">Timezone</label>
        <div class="mt-1 flex items-center gap-2">
          <span>{{ bot.timezone || '-' }}</span>
          <vs-icon icon="schedule"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideListMenu from '@/components/common/SideListMenu'
import { MENU_ITEMS } from '@/utils/editor.constants'
import { BOT_LANGUAGES } from '@/utils/bot.constants'
import { marketNameForBot, multiBotNameForBot } from '@/utils/market.utils'

export default {
  name: 'SettingsBotMarketEditor',

  components: {
    SideListMenu
  },

  props: {
    bot: {
      type: Object,
      required: true
    },
    multiBots: {
      type: Array,
      default: () => []
    }
  },

  emits: ['display-bot-summary', 'request-delete-market'],

  computed: {
    menuItems() {
      return ['111', '222'].includes(this.bot.id) ? [] : [MENU_ITEMS.delete]
    },
    groupBotName() {
      return multiBotNameForBot(this.bot)
    },
    // A market's name is only ever edited on the Markets page (Settings > Markets) — never
    // shown/renamed as the bot variant's own name here.
    marketName() {
      return marketNameForBot(this.bot)
    },
    marketLanguage() {
      const language = BOT_LANGUAGES.find(item => item.value === this.bot.language)
      return language ? language.text : '-'
    }
  }
}
</script>
